const validHexColor = (value) => /^#[\da-f]{6}$/i.test(value || '') ? value : null;

export const ticketStatusHex = (ticket, ticketTypes) => {
	const type = (ticketTypes || []).find((item) => String(item.id) === String(ticket && ticket.type));
	const color = (type && type.statusColors || []).find((item) => item && item.status === ticket.status);
	return validHexColor(color && color.hexColor);
};

export const ticketStatusBackground = (ticket, ticketTypes) => {
	const color = ticketStatusHex(ticket, ticketTypes);
	return color ? `${color}33` : 'var(--v-accent-base)';
};
